import {
  customerUpdateAction
} from '../../services/apis'
import {
  hasError,
  isServerResponseError,
} from '../common'

const editAction = async (id, data) => {
  const response = await customerUpdateAction(id, data)
  return isServerResponseError(response) || hasError(response)
    ? 'failed'
    : 'success'
}

export default editAction